<template>
  <div v-if="order">
    <a-row type="flex" justify="center" style="paddingBottom:55px">
      <a-col span="22">
        <a-steps :current="current" :status="status">
          <a-step
            v-for="item in tabs"
            :key="item.text"
            :title="item.text"
            :description="item.time"
          ></a-step>
        </a-steps>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-list itemLayout="vertical">
      <a-list-item-meta>
        <span slot="description">订单编号：{{ order.order_no }}</span>
        <b style="font-size:16px;color:#35B5FE" slot="title"
          >订单状态：{{ order.status_name }}</b
        >
      </a-list-item-meta>
      <a-list-item style="padding-left:20px;">
        <h4>申请职位：{{ job.name }}</h4>
        <h4>申请公司：{{ job.company.name }}</h4>
        <!-- <h4>申请时间：{{ order.created_at }}</h4> -->
        <!-- slot="actions"
        v-if="
          status === 'process' &&
            order.ie_user_id == $store.state.user.uid &&
            isGranted('post_manager.post_process_list.btn_list_audit')
        " -->
        <div>
          <template v-if="order.status == '9'">
            <a-button
              type="primary"
              style="margin-right:20px"
              @click.stop="handleSubmit(1)"
              >推荐</a-button
            >
            <a-button
              type="danger"
              style="margin-right:20px"
              @click.stop="handleSubmit(2)"
              >拒绝</a-button
            >
            <!-- <a-button type="link" @click="$refs.commentModal.show(order)">软性点评</a-button>
            <a-button type="link">附件简历</a-button>-->
          </template>
          <template v-if="order.status == '1'">
            <a-button
              type="primary"
              style="margin-right:20px"
              @click="handleSubmit(3)"
              >录用</a-button
            >
            <a-button
              type="primary"
              style="margin-right:20px"
              @click="handleSubmit(5)"
              >放弃</a-button
            >
          </template>
          <template v-if="order.status == '2'">
            <a-button
              type="primary"
              style="margin-right:20px"
              @click="handleSubmit(4)"
              >已到岗</a-button
            >
            <a-button
              type="success"
              style="margin-right:20px"
              @click="handleSubmit(7)"
              >取消录用</a-button
            >
            <a-button
              type="danger"
              @click="giveUp(5)"
              >放弃</a-button
            >
          </template>
          <template v-if="order.status == '3'">
            <a-button
              type="success"
              style="margin-right:20px"
              @click="handleSubmit(6)"
              >支付工资</a-button
            >
            <a-button
              type="danger"
              style="margin-right:20px"
              @click="handleSubmit(7)"
              >取消录用</a-button
            >
            <a-button
              type="success"
              style="margin-right:20px"
              @click="handleSubmit(8)"
              >工作完成</a-button
            >
          </template>
        </div>
      </a-list-item>
    </a-list>
    <div class="order-info">
      <div
        class="btn"
        @click="viewMoreInfo = !viewMoreInfo"
        v-if="order.timeline.length > 1"
      >
        <span v-show="!viewMoreInfo">
          展开
          <a-icon type="down"></a-icon>
        </span>
        <span v-show="viewMoreInfo">
          收起
          <a-icon type="up"></a-icon>
        </span>
      </div>
      <a-row type="flex" justify="start">
        <template v-for="(item, index) in order.timeline">
          <a-col :key="index" span="24" v-show="index === 0 || viewMoreInfo">
            <p :style="{ paddingLeft: index > 0 ? '30px' : '0' }">
              <a-icon
                v-if="index == 0"
                type="bell"
                style="margin-right:10px;"
              />
              {{
                `${order.resume_name}&nbsp;&nbsp;&nbsp;&nbsp;${item.time}&nbsp;&nbsp;&nbsp;&nbsp;${item.post_status_desc}`
              }}
            </p>
          </a-col>
        </template>
      </a-row>
    </div>
    <a-tabs defaultActiveKey="0">
      <a-tab-pane tab="报名信息" key="0">
        <Registration :resume="resume" @view="$refs.preview.show(order.report.attachment)"></Registration>
      </a-tab-pane>
      <a-tab-pane tab="职位信息" key="1">
        <Position :detail="job"></Position>
      </a-tab-pane>
      <a-tab-pane tab="公司信息" key="2">
        <company :company="job.company"></company>
      </a-tab-pane>
      <a-tab-pane tab="录取信息" key="3">
        <template  v-if="employ_info.employ != null || employ_info.entry != null">
          <template v-if="employ_info.employ != null">
            <a-row type="flex" align="middle" :gutter="15" style="margin-bottom: 20px;">
              <a-col>
                <span style="height:25px;border-left:3px solid #35B5FE;"></span>
              </a-col>
              <a-col>
                <b>录取信息</b>
              </a-col>
            </a-row>
            <a-row type="flex" align="top">
              <a-col :span="12">
                <p class="height-100">
                  实际到岗日期：{{employ_info.employ.time}}
                </p>
              </a-col>
              <a-col :span="12">
                <p class="height-50">
                  基本薪资：{{ employ_info.employ.basic_salary }}元 / {{basic_salary_period[employ_info.employ.basic_salary_period]}}
                </p>
              </a-col>
            </a-row>
            <a-row type="flex" align="top">
              <a-col :span="12">
                <p class="height-100">
                  结算方式：{{settlement_method[employ_info.employ.settlement_method]}}
                </p>
              </a-col>
              <a-col :span="12">
                <p class="height-50">
                  提成类型：{{ employ_info.employ.bonus_value || '无' }}{{ employ_info.employ.bonus_type==2?'%':employ_info.employ.bonus_type==3?'元/件':'' }}
                </p>
              </a-col>
            </a-row>
          </template>
          <template v-if="employ_info.entry != null && order.status == 3">
            <a-row type="flex" align="middle" :gutter="15" style="margin-bottom: 20px;">
              <a-col>
                <span style="height:25px;border-left:3px solid #35B5FE;"></span>
              </a-col>
              <a-col>
                <b>到岗信息</b>
              </a-col>
            </a-row>
            <a-row type="flex" align="top">
              <a-col :span="12">
                <p class="height-100">
                  实际到岗日期：{{employ_info.entry.time}}
                </p>
              </a-col>
              <a-col :span="12">
                <p class="height-50">
                  基本薪资：{{ employ_info.entry.basic_salary }}元 / {{basic_salary_period[employ_info.entry.basic_salary_period]}}
                </p>
              </a-col>
            </a-row>
            <a-row type="flex" align="top">
              <a-col :span="12">
                <p class="height-100">
                  结算方式：{{settlement_method[employ_info.entry.settlement_method]}}
                </p>
              </a-col>
              <a-col :span="12">
                <p class="height-50">
                  提成类型：{{ employ_info.entry.bonus_value || '无' }}{{ employ_info.entry.bonus_type==2?'%':employ_info.entry.bonus_type==3?'元/件':'' }}
                </p>
              </a-col>
            </a-row>
          </template>
        </template>
        <template v-else>
          <a-empty />
        </template>
      </a-tab-pane>
      <a-tab-pane tab="工资结算" key="4">
        <WageSettlement :details="settlement_apply" :order="order" ></WageSettlement>
      </a-tab-pane>
    </a-tabs>
    <resume-preview-modal ref="preview"></resume-preview-modal>
  </div>
</template>
<script>
import Registration from "./tabs/registration";
import Position from "./tabs/position";
import moment from "moment";
import Company from "./tabs/company";
import WageSettlement from "./tabs/wageSettlement";
import Api from "@/api";
import baseComponentVue from "@/components/base-component.vue";
import PartTimeOfferDialog from "./components/dialogs/partTimeOfferDialog";
import ComplainDialog from "./components/dialogs/complainDialog";
import CancelOffer from "./components/dialogs/cancelOffer";
import PayDialog from "./components/dialogs/payDialog";
import ResumePreviewModal from "@/components/resume-preview-modal";
export default {
  name: "PartTimeExamine",
  extends: baseComponentVue,
  props: {
    id: {
      default: -1
    }
  },
  data() {
    return {
      orderStatus: this.$route.params.status,
      viewMoreInfo: false,
      tabs: [],
      job: undefined,
      order: undefined,
      showAlert:false,
      resume:{},
      employ_info:{},
      basic_salary_period: ['', '小时', '天', '周', '月', '次', '其他'],
      settlement_method: ['', '日结', '周结', '月结', '完工结'],
      bonus_type: ['', '无提成', '业绩提成', '计件提成', '自定义'],
      contactTypeData: ['', '微信', '微信公众号', '电话联系', 'QQ', 'QQ群', '不要主动联系我'],
      settlement_apply:''
    };
  },
  components: {
    Registration,
    Position,
    Company,
    WageSettlement,
    PartTimeOfferDialog,
    ComplainDialog,
    CancelOffer,
    PayDialog,
    ResumePreviewModal
  },
  computed: {
    post_id() {
      if (this.id < 0) {
        return this.$route.params.id;
      } else {
        return this.id;
      }
    },
    //step
    current() {
      let status = this.order.status;
      let arr = [
        [9,10,11],
        [1,6],
        [2,7,8],
        [3,7,8],
        [5],
        [6, 7, 8]
      ];
      return arr.findIndex(item => item.indexOf(status) > -1);
    },
    /**
     * return [-1(process),0(error),1(finish)]
     */
    status() {
      let status = this.order.status;
      let arr = [
        [6,7,8,10,11,14],
        [5]
      ];
      let i = arr.findIndex(item => item.indexOf(status) > -1);
      return i == -1 ? "process" : i == 0 ? "error" : "finish";
    }
  },
  created() {
    this.getDetails();
  },
  methods: {
    async getDetails() {
      let data = await Api.order.columbusJobDetail({
        url:`/post/ie/${this.post_id}`,
        method:'get',
        json:{}
      });
      this.job = data.post.job;
      this.order = data.post;
      this.tabs = data.post.timeline;
      this.employ_info = data.post.employ_info;
      if(data.post.settlement_apply){
        this.settlement_apply = data.post.settlement_apply
      }
      if(data.post.resume.length == 0){
        this.resume = {};
      }else{
        this.resume = data.post.resume
      }
    },
    //录用
    handleSubmit(status){
      const statusArray = {
        1:'recommend',//推荐
        2:'rejected',//拒绝
        3:'employment',//录用
        4:'haveArrived',//已到岗
        5:'giveUp',//放弃
        6:'payWages',//支付工资
        7:'cancelEmployment',//取消录用
        8:'completion',//工作完成
      }
      this.$emit(statusArray[status],this.order)
    },
  }
};
</script>
<style lang="scss" scoped>
.order-info {
  margin: 10px 0 38px;
  border: 1px solid #35b5fe;
  background: rgb(224, 244, 255);
  padding: 15px 20px 2px;
  position: relative;
  .btn {
    cursor: pointer;
    z-index: 10;
    position: absolute;
    right: 10px;
  }
  .reason {
    color: rgb(238, 88, 88);
    padding-left: 30px;
  }
}
</style>
